import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import styles from './index.less';
import Store from './store';

const PhotoDetailModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.ImageDetailModalRoot}>
        <div className={styles.imagePanel}>
          <Link
            className={styles.closeBtn}
            onClick={() => {
              store.onClickClose();
              onClose();
            }}
          />
          <div data-hide-txt onClick={store.downloadCrossOriginImage} className={styles.downBtn}>
            下载
          </div>
          <img id={'expand-img'} src={store.src} alt={store.name} />
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(PhotoDetailModal, Store);
